import {
  Button,
  Grid,
  Menu,
  MenuItem,
  Snackbar,
  Typography,
  makeStyles, Card, CardContent,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as toolAction from "../actions/toolAction";
import * as toolsOfferedAction from "../actions/toolsOfferedAction";
import * as usersAction from "../actions/userActions";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import {
  createNewToolService,
  updateToolService,
  deleteToolService,
  getBulkEmailContents,
  getBulkEmailSendToUser
} from "../services/ToolsOfferedService";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import { DELETE_SERVICE_ERROR_MESSAGE } from "../utilities/applicationutils";
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.TOOLS_OFFERED;

const ToolsOffered = ({
  modelState,
  getModels,
  updateModel,
  setSnackBar,
  onCloseSelected,
  getTools,
  getToolsOffered,
  toolState,
  toolsOfferedState,
  getSalesOfficeList,
  getCurrency,
  salesOfficeData,
  currencyState
}) => {
  const [models, setModels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewModel, setShowNewModel] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [bulkEmailSendToPayload, setBulkEmailSendToPayload] = useState({});
  const [showSendBulkEmailModel, setShowSendBulkEmailModel] = useState(false);
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [htmlContent, setHtmlContent] = useState('');


  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);
  const [toolName, setToolName] = useState("");
  const [firstYearFee, setFirstYearFee] = useState(0);
  const [renewalFee, setRenewalFee] = useState(0);
  const [toolId, setToolId] = useState("");
  const [toolsOfferedId, setToolsOfferedId] = useState("");
  const [toolSelection, setToolSelection] = useState("");
  const onNewProjectClick = () =>{ setToolSelection(""); setFirstYearFee(0); setRenewalFee(0); setShowNewModel(true)};
  const retriveSalesOfficeId = localStorage.getItem("salesOfficeValue");
  const [regionSelectedId, setRegionSelectedId] = useState(localStorage.getItem("regionIdValue"));
  const [currencyUnit, setCurrencyUnit] = useState(localStorage.getItem("currencySymbolValue"));
  const handleToolSelection = (e) => {
    const selectedId = e.target.value;
    const isToolSelected = toolsOfferedState && toolsOfferedState.some((tool) => tool.toolId === selectedId);
    if (isToolSelected) {
      setToolId("");
      setToolName("");
      setToolSelection("");
      setSnackBar(true,"error","This tool is not allowed as it is already offered.");
      setLoading(false);
      return false;
    }
    setToolId(selectedId);
    setToolSelection(selectedId);
    return true;
  };

  const onEdit = (offerId, id, data, fYearFee, rFee) => {
    setToolsOfferedId(offerId);
    setToolId(id);
    setToolName(data);
    setFirstYearFee(fYearFee);
    setRenewalFee(rFee);
    setShowEdit(true);
  };

  const onDelete = (id, data) => {
    setToolId(id);
    setToolName(data);
    setShowDelete(true);
  };
  const isModelRegionPresent = (selectedModal, regionId, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        selectedModal?.modelName.toLowerCase() ==
          model.modelName.toLowerCase() &&
        regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const onSendBulkEmail = (toolOffered) => {
    console.log(toolOffered);
    setBulkEmailSendToPayload({
      toolsOfferedId : toolOffered.toolsOfferedId,
      userEmail : localStorage.getItem("userEmailAddress")
    })
    console.log("prepayload", bulkEmailSendToPayload)
    callGetBulkEmailMailContent(toolOffered);
  }

  const callGetBulkEmailMailContent = async (toolOffered) => {
    setLoading(true)
    setShowSendBulkEmailModel(true);
    console.log("payload", bulkEmailSendToPayload);
    try{
      await getBulkEmailContents(toolOffered).then((response) => {
        const data = response.data;
        setEmail(data.sendTo);
        setSubject(data.subject);
        setHtmlContent(data.body);

        setShowSendBulkEmailModel(true);
        setLoading(false);
      })
        .catch((error) =>{
          setSnackBar(true,"error", error?.response?.data?.errorMessage || "Internal service problem!");
          setLoading(false);
          setShowSendBulkEmailModel(false);
        })
    }
    catch(error){
      setLoading(false);
    }
  }

  const handleBulkEmailSendTo = async() => {
    setLoading(true)
    try{
      await getBulkEmailSendToUser(bulkEmailSendToPayload).then((response) => {
        // await getEmailContents(emailSendToPayload).then((response) => {
        const data = response.data;
        // const plainTextBody = stripHtml(data.body);
        // const mailtoLink = `https://outlook.office.com/?path=/mail/action/componse&to:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`;
        // const mailtoLink = `mailto:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`
        //window.location.href = mailtoLink;
        // window.open(mailtoLink, "_blank");
        setShowSendBulkEmailModel(false);
        setLoading(false);
        setSnackBar(true, "success", "Email sent succesfully.");
      })
        .catch((error) =>{
          setSnackBar(true,"error", error?.response?.data?.errorMessage || "Internal service problem!");
          setLoading(false);
          setShowSendBulkEmailModel(false);
        })
    }
    catch(error){
      setLoading(false);
    }
  }
  const onUpdateModelName = async (value, model) => {
    const { isSame, isPresent } = isModelPresent(
      value,
      model,
      modelState.models.data
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(true, "error", "Model Name already exists");
      setGridData([]);
      setModels([...models]);
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: value,
          regionId: model.regionId,
          isActive: model.status,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(true, "success", `Model name updated`);
          await getModels();
          setModels(modelState.models.data);
          setSnackBar(true, "success", `${value} has been updated`);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating model ${model?.model}`
        );
      }
    }
  };

  useEffect( () => {
    const fetchTools = async () => {
      try {
        await Promise.all([
          getSalesOfficeList(),
          getCurrency(),
          getTools(),
          getToolsOffered(retriveSalesOfficeId)
        ]);
      } catch (error) {
        console.log("get tools offered fails", error);
      }
    }
    fetchTools()
  }, [getSalesOfficeList, getCurrency, getTools, getToolsOffered]);

  
  useEffect(() => {
    const ctrlData = [];
    toolsOfferedState &&
      toolsOfferedState.forEach((model) => {
        const compareToolName = toolState && toolState.find((tool) => tool.toolId == model.toolId);
        const salesOfficeInfo = salesOfficeData && salesOfficeData.find((s) => s.salesOfficeId == retriveSalesOfficeId);
        const currency = currencyState && currencyState?.data.find(c => c.currencyId === salesOfficeInfo.currencyId);
        ctrlData.push({
          rowKey: model.toolId,
          toolsOfferedId: model.toolsOfferedId,

          toolId: model.toolId,
          toolName: compareToolName && compareToolName.toolName,
          firstYearFee: `${model.firstYearFee} ${currency ? currency.currencySymbol : ''}`,
          renewalFee: `${model.renewalFee} ${currency ? currency.currencySymbol : ''}`,
          rowValue: [
            {
              colType: "user-grid-label",
              colOptions: {
                value: compareToolName && compareToolName.toolName,
                tab: "tools",
                model: model,
                onUpdate: onUpdateModelName,
              },
            },
            {
              colType: "grid-label",
              colOptions: {
                width: "100px",
                value: `${model.firstYearFee} ${currency ? currency.currencySymbol : ''}`,
                tab: "tools",
                model: model,
                onUpdate: onUpdateModelName,
              },
            },
            {
              colType: "grid-label",
              colOptions: {
                width: "100px",
                value: `${model.renewalFee} ${currency ? currency.currencySymbol : ''}`,
                tab: "tools",
                model: model,
                onUpdate: onUpdateModelName,
              },
            },
            {
              colType: "grid-actions",
              colOptions: [
                ...(model.hasSoftwareUpdate? [{
                  name: "email",
                  tab: "models",
                  action: () => onSendBulkEmail(model),
                  width: "850px",
                }] :[]),
                {
                  name: "edit",
                  tab: "tools",
                  action: (e) => onEdit(model.toolsOfferedId, model.toolId, compareToolName.toolName, model.firstYearFee, model.renewalFee),
                  width: "850px",
                },
                {
                  name: "delete",
                  action: () => onDelete(model.toolsOfferedId, compareToolName.toolName),
                },
              ],
            },
          ],
        });
      });
    setGridData(ctrlData);
  }, [toolsOfferedState, searchValue, sortBy, isUnsaveChanges]);  
  
  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    emailCardPaper: {
      position: "absolute",
      width: "60%",
      backgroundColor: "#F0F0F4",
      padding: "15px 15px 15px",
      height: "80%",
      overflowY: "auto"
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "44% 25% 25% 6%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);
  _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);
  const isModelPresent = (modelName, selectedModel, data) => {
    let isPresent = false;

    if (modelName === selectedModel.modelName) {
      return { isSame: true, isPresent };
    }

    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };
  const handleCreateModel = async () => {
    if(toolId && firstYearFee && renewalFee){
    try {
      setLoading(true);
      const payload = {
        toolId: toolId,
        salesOfficeId: retriveSalesOfficeId,
        firstYearFee: parseInt(firstYearFee),
        renewalFee: parseInt(renewalFee)
      };
      await createNewToolService(payload).then( async (response) => {
      await getToolsOffered(retriveSalesOfficeId);
      const compareToolName = toolState && toolState.find((tool) => tool.toolId === toolId);
      setSnackBar(true, "success", `New tool created: ${compareToolName?.toolName}`);
      setLoading(false);
      setShowNewModel(false);
      setToolSelection("");
      setFirstYearFee("");
      setRenewalFee("");
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowNewModel(true);
    })
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(true,"error",`Error while creating a new tool${toolName}`);
    }
  }
  else{
    setLoading(false);
    setSnackBar(true,"error",`Please select tool, enter First Year Fee and Renewal Fee!`);
  }
  };

  const handleEditTool = async () => {
    if(toolId && firstYearFee && renewalFee){
    try {
      setLoading(true);
      const payload = {
        toolsOfferedId: toolsOfferedId,
        toolId: toolId,
        salesOfficeId: retriveSalesOfficeId,
        firstYearFee: parseInt(firstYearFee),
        renewalFee: parseInt(renewalFee)
      };
      await updateToolService(toolsOfferedId, payload).then(async (response) => {
      getToolsOffered(retriveSalesOfficeId);
      setSnackBar(true, "success", `Tool updated: ${toolName}`);
      setLoading(false);
      setShowEdit(false);
      setFirstYearFee("");
      setRenewalFee("");
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowEdit(true);
    })
    } catch (error) {
      setShowEdit(false);
      setSnackBar(true, "error", `Error while updating a new tool`);
      setLoading(false);
    } 
  } 
    else {
      setLoading(false);
      setSnackBar(true,"error",`Please select tool, enter First Year Fee and Renewal Fee!`);
    }
  };

  const deleteConfirm = async () => {
    try {
      const payload = {
        toolId: toolId,
        toolName: toolName,
      };
      await deleteToolService(payload.toolId).then( async (response) => {
      await getToolsOffered(retriveSalesOfficeId);
      setSnackBar(true, "success", `${toolName} has been deleted.`);
      setLoading(false);
      setShowDelete(false);
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowDelete(false);
    })
    } catch (error) {
      setSnackBar(true, "error", `Error while deleting model ${toolName}`);
      setLoading(false);
    }
  };


  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={11} className="page-content">
        {/* <Grid container item xs={12} md={5} className="page-menu"></Grid> */}

        <Grid item container xs={12} md={12} justify="flex-end">
          <CustomButton
            id="newModel"
            showGradient={true}
            variant="contained"
            color="primary"
            disabled={false}
            name="Add Tool Offered"
            onClick={onNewProjectClick}
          />
        </Grid>
        {gridData?.length == 0 && (
          <Grid item container xs={12} md={11}>
            <Typography
              className="filter-label"
              gutterBottom
              sx={{ paddingLeft: 10 }}
            >
              No Records Found.
            </Typography>
          </Grid>
        )}
        <Grid item container xs={12} md={11}>
          {gridData?.length > 0 && (
            <DMGrid
              key={Math.random()}
              headers={MODELS_CONTROLS.GRID_HEADERS}
              headerClassName={classes.gridHeaderColumns}
              data={gridData}
              loading={loading}
              setGridData={(t) => {
                setGridData(t);
              }}
            />
          )}{" "}
        </Grid>
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New Tool Offered</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Select Tool*"}
                variant="outlined"
                value={toolSelection}
                onChange={handleToolSelection}
                placeholder="Select Tool*"
              >
                {toolState &&
                  toolState.map((tools) => {
                    return (
                      <MenuItem key={tools.toolId} value={tools.toolId}>
                        {tools.toolName}
                      </MenuItem>
                    );
                  })}
              </TextField>
              <TextField
                required
                id="outlined-basic-userName"
                label="First Year Fee"
                variant="outlined"
                type="number"
                min={0}
                value={firstYearFee}
                onChange={(e) => setFirstYearFee(e.target.value)}
                autoComplete="off"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">{currencyUnit}</InputAdornment>
                    ),
                  },
                }}
                onKeyDown={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                        "Tab",
                      ].includes(e.code)
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                      return false;
                    }
                  }
                }}
              />
              <TextField
                required
                id="outlined-basic-userName"
                label="Renewal Fee"
                variant="outlined"
                type="number"
                min={0}
                value={renewalFee}
                onChange={(e) => setRenewalFee(e.target.value)}
                autoComplete="off"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">{currencyUnit}</InputAdornment>
                    ),
                  },
                }}
                onKeyDown={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                        "Tab",
                      ].includes(e.code)
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                      return false;
                    }
                  }
                }}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateModel}
                    // disabled={isDisabled}
                    className="makeStyles-gradient-27"
                  >
                    Add Tool
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMModal open={showEdit} onClose={() => setShowEdit(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">Edit Tool Offered</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                disabled
                id="outlined-basic-userName"
                label="Tool Name"
                variant="outlined"
                type="text"
                value={toolName}
                onChange={(e) => setToolName(e.target.value)}
              />
              <TextField
                id="outlined-basic-userName"
                label="First Year Fee"
                variant="outlined"
                type="number"
                min={0}
                value={firstYearFee}
                onChange={(e) => setFirstYearFee(e.target.value)}
                autoComplete="off"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">{currencyUnit}</InputAdornment>
                    ),
                  },
                }}
                onKeyDown={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                        "Tab",
                      ].includes(e.code)
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                      return false;
                    }
                  }
                }}
              />
              <TextField
                id="outlined-basic-userName"
                label="Renewal Fee"
                variant="outlined"
                type="number"
                min={0}
                value={renewalFee}
                onChange={(e) => setRenewalFee(e.target.value)}
                autoComplete="off"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="start">{currencyUnit}</InputAdornment>
                    ),
                  },
                }}
                onKeyDown={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Home",
                        "End",
                        "Tab",
                      ].includes(e.code)
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                      return false;
                    }
                  }
                }}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowEdit(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleEditTool}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          // title={"Are you sure to delete?"}
          contentText={`${toolName} will be deleted.`}
          discardText={"Cancel"}
          agreeText={"OK"}
          onProceed={() => {
            deleteConfirm(toolName);
          }}
        />

        {/* Dialog for unsave chabges warning */}
        <DMDeleteDialog
          open={unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={"Warning"}
          contentText={`You have unsaved changes, On close you will loose all your changes. Are you sure you want to close?`}
          discardText={"Cancel"}
          agreeText={"Yes"}
          onProceed={() => {
            onCloseSelected({
              id: "",
              isClosed: true,
            });
            setUnsaveChangePopup(false);
            setIsUnsaveChanges(false);
          }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setShowMoreOptions(false);
          }}
        ></Menu>


        <DMModal open={showSendBulkEmailModel} onClose={() => setShowSendBulkEmailModel(false)}>
          <div style={modalStyle} className={classes.emailCardPaper}>
            <div>
              {/*<h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'5px' }}>{editCustomerId? "Edit" : ""} Send License Email </h3>*/}
              <Typography className={classes.headerLabelStyle}>To: {email} </Typography>
              <Typography className={classes.headerLabelStyle}>Subject: {subject}</Typography>
            </div>
            <div>
              <Card variant="outlined" className={classes.cardContainer}>
                <CardContent>
                  <div height='200px' overflow= 'auto' dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </CardContent>
              </Card>
            </div>
            <div style={{ display: "flex",marginTop:"50%",flexDirection: "row", gap: 5 }}>
              <Grid
                item
                xs={12}
                container
                style={{ justifyContent: "center" }}
              >
                <Grid item xs={6} style={{ paddingLeft: '35%',justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowSendBulkEmailModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleBulkEmailSendTo}
                    className="makeStyles-gradient-27"
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </div>
            {/* </div> */}
          </div>
        </DMModal>



      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>


  );
};

const mapStateToProps = (state) => ({
  salesOfficeData : state.usersList.users.salesOfficeList || [],
  currencyState: state.model.currency,
  toolState: state.tool.tools.data || [],
  toolsOfferedState: state.toolOffered.tools.data || [],
  modelState: state.model,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getTools: async () => dispatch(toolAction.getTools()),
    getToolsOffered: async (retriveSalesOfficeId) => dispatch(toolsOfferedAction.getToolsOffered(retriveSalesOfficeId)),
    getSalesOfficeList: async() => dispatch(usersAction.getSalesOfficeList()),
    getCurrency: async() => dispatch(modelAction.getCurrency()),
    createNewTool: async (requestPayload) =>
      dispatch(toolsOfferedAction.createNewTool(requestPayload)),
    updateTool: async (toolsOfferedId, requestPayload) =>
      dispatch(toolsOfferedAction.updateTool(toolsOfferedId, requestPayload)),
    deleteTool: async (requestPayload) =>
      dispatch(toolsOfferedAction.deleteTool(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    // onPageSelected: (selectedPage) =>
    //   dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolsOffered);
